import { useState } from "react";
import { resolveTourId } from "@utils/mode_tool/modeRoute";

function useMapBoundaries() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTour, setSelectedTour] = useState(null);
  const [isPickingPoints, setIsPickingPoints] = useState(false);

  function openFromTour(tour, tourId = "") {
    const resolvedTourId = tourId || resolveTourId(tour);
    if (!tour || !resolvedTourId) return false;
    setSelectedTour(tour);
    setIsOpen(true);
    setIsPickingPoints(true);
    return true;
  }

  function close() {
    setIsOpen(false);
    setSelectedTour(null);
    setIsPickingPoints(false);
  }

  function togglePickingPoints() {
    setIsPickingPoints((prev) => !prev);
  }

  return {
    isOpen,
    selectedTour,
    isPickingPoints,
    setIsPickingPoints,
    togglePickingPoints,
    openFromTour,
    close,
  };
}

export default useMapBoundaries;

